/**
 * User Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserCustomAttributeModel } from './userCustomAttributeModel';


export interface DirectoryUser { 
    userId?: number;
    username?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    organizationId?: number | null;
    sourceDirectoryID?: number | null;
    isLocked?: boolean;
    password?: string | null;
    email?: string | null;
    userPrincipalName?: string | null;
    udsystemGroupId?: number | null;
    createdBy?: string | null;
    createdDate?: string;
    modifiedBy?: string | null;
    modifiedDate?: string;
    isActive?: boolean | null;
    phone?: string | null;
    cell?: string | null;
    fax?: string | null;
    streetAddress?: string | null;
    pobox?: string | null;
    city?: string | null;
    state?: string | null;
    postalCode?: string | null;
    countryId?: number | null;
    jobTitle?: string | null;
    manager?: string | null;
    department?: string | null;
    costCenter?: string | null;
    location?: string | null;
    workCountry?: string | null;
    employeeNumber?: string | null;
    employeeType?: string | null;
    isMustChangePassword?: boolean | null;
    distinguishedName?: string | null;
    immutableId?: string | null;
    organizationMnemonic?: string | null;
    isDeleted?: boolean;
    tokenState?: string | null;
    userType?: string | null;
    customerAttributes?: Array<UserCustomAttributeModel> | null;
}

